import React from 'react';
import MarketingLayout from '../components/MarketingLayout';

const privacySections = [
  {
    title: '1. Introduction',
    content:
      'Better Husband ("we", "our" or "Application") is committed to protecting your privacy. This Privacy Policy explains how we collect, use and protect your personal information when you use our mobile application and services.',
  },
  {
    title: '2. Information We Collect',
    content: 'We collect the following categories of information:',
    list: [
      'Profile information: name, email, language preferences',
      'Relationship data: relationship duration, number of children, communication and stress levels',
      'Usage data: suggestions viewed, feedback provided, check-ins completed',
      'Personal notes: notes you choose to save in the app',
      'Payment data: securely processed by Stripe (we do not store card data)',
    ],
  },
  {
    title: '3. How We Use Your Information',
    content: 'We use the collected information to:',
    list: [
      'Personalize daily suggestions based on your profile',
      'Improve the recommendation algorithm',
      'Send you notifications and reminders (if enabled)',
      'Process payments for premium features',
      'Improve and optimize the application',
    ],
  },
  {
    title: '4. Information Sharing',
    content:
      'We do not sell, rent or share your personal information with third parties for marketing purposes. We only share information with:',
    list: [
      'Service providers (hosting, payment processing) necessary for app operation',
      'Legal authorities when required by law',
      'OpenAI, the AI provider that generates your daily gestures. To do this we send it the answers you gave at setup, your recent gestures, the notes and check-ins you wrote, the dates you added and, if you entered it, your partner’s first name. We do not send your name, email address or payment details.',
    ],
  },
  {
    title: '5. Analytics & Usage Statistics',
    content:
      "We use Google Firebase Analytics (Google Ireland Limited) to understand how the App is used and to improve it. We collect installation identifiers, device type, language, aggregated usage events and app version; we do not collect the content of your notes or sensitive data. The legal basis is your consent (Art. 6.1.a GDPR), expressed by accepting this Privacy Policy. You can withdraw consent at any time by writing to support.betterhusband@gmail.com. Data may be transferred outside the EU under the European Commission's Standard Contractual Clauses.",
  },
  {
    title: '6. Data Security',
    content:
      'We implement technical and organizational security measures to protect your information, including encryption of data in transit and at rest, limited access to personal data, and regular security monitoring.',
  },
  {
    title: '7. Your Rights',
    content: 'You have the right to:',
    list: [
      'Access your personal data',
      'Request correction of inaccurate data',
      'Request deletion of your data',
      'Export your data in readable format',
      'Withdraw consent at any time',
    ],
  },
  {
    title: '8. Data Retention',
    content:
      'We retain your personal data for as long as your account is active or as needed to provide you with services. You can request deletion of your account and associated data at any time by contacting us.',
  },
  {
    title: '9. Contact',
    content:
      'For privacy questions or to exercise your rights, contact us at: support.betterhusband@gmail.com',
  },
];

const LandingPrivacy = () => {
  return (
    <MarketingLayout>
      <main className="bh-container" style={{ paddingTop: 64, paddingBottom: 96, flex: 1 }}>
        <div style={{ maxWidth: 'var(--measure)', margin: '0 auto' }}>
          <span className="bh-eyebrow">Legal</span>
          <h1 style={{ fontSize: 'clamp(2.2rem, 4vw, 3rem)', marginBottom: 8 }}>Privacy Policy</h1>
          <p style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 48 }}>Last updated: September 30, 2026</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 36 }}>
            {privacySections.map((section, index) => (
              <div key={index}>
                <h2 style={{ fontSize: '1.3rem', marginBottom: 10 }}>{section.title}</h2>
                <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>{section.content}</p>
                {section.list && (
                  <ul style={{ marginTop: 12, paddingLeft: 4, listStyle: 'none' }}>
                    {section.list.map((item, i) => (
                      <li key={i} style={{ display: 'flex', gap: 12, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8 }}>
                        <span style={{ color: 'var(--terracotta)' }}>•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </MarketingLayout>
  );
};

export default LandingPrivacy;
